import { Component, OnInit } from "@angular/core";
import { HomeService } from "src/app/services/home.service";
import { NocPendingCountModel } from "src/app/model/NocPendingCountModel";

@Component({
  selector: "app-secure-home",
  templateUrl: "./nocPendingDashboard.component.html",
  styleUrls: ["./nocPendingDashboard.component.scss"],
})
export class nocPendingDashboardComponent implements OnInit {
  userName: string;
  nocPendingCountModel : NocPendingCountModel;
  loaded: boolean = false;
  date: Date;
  nocPendingCount:number;
  pendingList:any;
  rejectedNocCount : number;
  rejectedNocList : any;
  dataSource:any;
  rejectedDataSource :any;

  pageSize:any = 1;
  pageSizeOptions:any = [10,20,30];
  currentPage:any=0;
  pageChanged(event:any){
    console.log(event);
  }

  displayedColumns: string[] = [
    "id",
    "applicationNumber",
    "lotteryCOde",
    "schemeCode",
    "nocBank",
    "nocApplyDate",
    "delayDate"
    // "action",
  ];

rejectedDisplayColumn:string[] = [
  "id",
  "applicationNumber",
  "nocStatus",
  "nocApplyDate",
  "rejectionRemark",
  "rejectedBy"
]

  constructor(private homeService: HomeService) { }

  showTable : boolean= false;
  showRejectedStatusTable :  boolean= false;

  ngOnInit(): void { 
    this.nocPendingCOuntAndDetails();
  }
  nocPendingCOuntAndDetails(){
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    this.nocPendingCount = null;
    this.homeService.fetchnOCPendingCount().subscribe((data:any)=>{
      this.nocPendingCount = data.pendingNocCount;
      this.dataSource = data.pendingList;
      this.rejectedNocCount = data.rejectedNocCount;
      this.rejectedDataSource = data.rejectedNocList;
      console.log(data. rejectedNocCount,"rejected Call");
      console.log(data. rejectedNocList,"rejected List");
      console.log(data,"fromList");
      this.loaded = true;
      this.date = new Date();
    },(err:any)=>{
      console.log(err," error Method Called")
    });
  }

  refresh() {
    this.ngOnInit();
  }

}